<template>
  <div class="bsp-header">
    <h1>Bao Sparring Partner (Beta)</h1>
    <p class="subtitle">Practice your sales calls with an AI sparring partner</p>
  </div>
</template>

<script>
export default {
  name: "BSPHeader"
}
</script>

<style lang="scss" scoped>
.bsp-header {
  margin-bottom: 0.5rem;

  h1 {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: $slate80;
  }

  .subtitle {
    color: $slate60;
    font-size: 1.1rem;
  }
}
</style>
